<h2 class="content-block dx-theme-background-color-as-text-color">{{ helpTitle }}</h2>
<div class="content-block">
    <div class="dx-card responsive-paddings dx-theme-accent-as-text-color">
      <app-help-text></app-help-text>
     </div>
</div>
